import { SingleIncomeStatementV1 } from "../../grader/single-income-statement/v1.grader";
import { AnswerConfig } from "../../grader/grade-input";
import { ExtractInput } from "../extract-input";
import { ExtractOutput } from "../extract-output";
import { extractTable } from "../utils/extract-table";
import { extractValueAndConfigFromCell } from "../utils/extract-value-from-cell";
import { getAccountAndLevel } from "../utils/get-account-and-level";

export function extractSingleIncomeStatementV1(
  extractInput: ExtractInput,
): ExtractOutput<SingleIncomeStatementV1[]> {
  const { version, questionType, div } = extractInput;
  const table = extractTable(div, `table.income-single-statement`);
  if (!table) throw new Error("테이블을 만들어주세요.");

  const sliceStart = 2; // 0: caption, 1: header 행이므로 데이터는 2번 인덱스부터 시작
  const flatAccountSheets: SingleIncomeStatementV1[] = [];

  // 테이블의 모든 <tr> 요소 가져오기
  const trs = table.getElementsByTagName("tr");

  // 헤더를 제외한 데이터 행만 순회
  for (const tr of Array.from(trs).slice(sliceStart)) {
    const tds = tr.getElementsByTagName("td");

    // 해당 행에서 계정명(name)과 계정의 레벨(level)을 추출
    const [name, level] = getAccountAndLevel(tr);

    // 각 열의 값 추출 (input/select/textContent 모두 대응)
    const values: string[] = [];
    const answerConfigs: (AnswerConfig | undefined)[] = [];
    Array.from(tds)
      .slice(1) // 첫 번째 열(계정명)을 제외하고 값 열만 순회
      .forEach((td) => {
        const { value, answerConfig } = extractValueAndConfigFromCell(td);
        values.push(value);
        answerConfigs.push(answerConfig);
      });

    // 추출된 데이터를 SingleIncomeStatementV1 형태로 추가
    flatAccountSheets.push({
      id: tr.id,
      name,
      values,
      level,
      answerConfigs,
    });
  }

  return {
    version, // 문제 버전
    questionType, // 문제 유형
    entryCount: flatAccountSheets.length, // 추출된 행 수
    answerSheet: flatAccountSheets, // 추출된 현금흐름표 데이터
  };
}
